import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ContentComponent } from '@app/shell/components/content/content.component';
import { SidebarComponent } from '@app/shell/components/sidebar/sidebar.component';
import { MainLoaderService } from '@hal/common';

@Component({
  selector: 'app-shell',
  imports: [RouterOutlet, SidebarComponent, ContentComponent],
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ShellComponent implements OnInit {
  constructor(private _mainLoaderService: MainLoaderService) {}

  ngOnInit(): void {
    this._mainLoaderService.hideLoader();
  }
}
